module.exports = __webpack_public_path__ + "static/media/bg-lettuce.cea61226.jpg";